import Vue from "vue"
import VueRouter, { Route } from "vue-router"
import store from "@/store"
import { HAS_USER_INFO } from "@/store/types/getters"
import { hasToken, isTokenExpired } from "@/utils/token"
import { isUndefined } from "lodash"
import { notifyInfo, notifyWarn } from "@/utils/notify"

Vue.use(VueRouter)

const routes = [
    {
        path: "/",
        name: "Home",
        redirect: "/login",
        meta: { requireLogin: false },
    },
    {
        path: "/dashboard",
        name: "Dashboard",
        component: () =>
            import(
                /* webpackChunkName: "dashboard" */ "../views/Dashboard.vue"
            ),
        meta: { requireLogin: true },
    },
    {
        path: "/login",
        name: "Login",
        component: () =>
            import(/* webpackChunkName: "login" */ "../views/Login.vue"),
        meta: { requireLogin: false },
        beforeEnter: (_to: Route, _from: Route, next: any) => {
            if (
                store.getters[HAS_USER_INFO] ||
                (hasToken() && !isTokenExpired())
            ) {
                return next({ name: "Dashboard" })
            } else {
                return next()
            }
        },
    },
    {
        path: "/customers",
        name: "CustomerList",
        component: () =>
            import(
                /* webpackChunkName: "customerlist" */ "../views/CustomerList.vue"
            ),
        meta: { requireLogin: true },
    },
    {
        path: "/customers/:marketId/dashboard",
        name: "CustomerDashboard",
        component: () =>
            import(
                /* webpackChunkName: "customerdashboard" */ "../views/CustomerDashboard.vue"
            ),
        meta: { requireLogin: true },
    },
    {
        path: "/customers/:marketId/shops",
        name: "ShopList",
        component: () =>
            import(/* webpackChunkName: "shoplist2" */ "../views/ShopList.vue"),
        meta: { requireLogin: true },
    },
    // {
    //     path: "/analytics",
    //     name: "Analytics",
    //     component: () =>
    //         import(
    //             /* webpackChunkName: "analytics" */ "../views/Analytics.vue"
    //         ),
    //     meta: { requireLogin: true },
    // },
    {
        path: "*",
        name: "Others",
        redirect: "/",
        meta: { requireLogin: false },
    },
]

const router = new VueRouter({
    routes,
})

router.beforeEach((to: Route, from: Route, next) => {
    const hasValidToken = hasToken() && !isTokenExpired()
    const hasUserInfo = store.getters[HAS_USER_INFO]

    if (!isUndefined(to.meta) && to.meta.requireLogin) {
        if (!hasValidToken && !hasUserInfo) {
            notifyInfo("Operation denied", "Please login")
            return next({ name: "Login" })
        }
    }

    if (hasValidToken && hasUserInfo && to.name === "Login") {
        notifyWarn("Operation denied", "Already logged in")
        return next(false)
    }

    if (!isUndefined(to.meta) && !isUndefined(to.meta.requireRole)) {
        if (Vue.prototype.$UAcsLogin.hasRole(to.meta.requireRole)) {
            return next()
        } else {
            notifyWarn(
                "Operation denied",
                `Only accessible to Role: "${to.meta.requireRole}"`
            )
            return next(false)
        }
    } else {
        return next()
    }
})

export default router
